import React, { useState, Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { Mic } from 'lucide-react';
import { motion } from 'framer-motion';

const SpiritAgentSheet = lazy(() => import('./SpiritAgentSheet'));

const HIDDEN_PATHS = ['/ketoscan', '/body-twin-evolved', '/login', '/register', '/onboarding', '/'];

export default function SpiritAgentFAB() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  if (HIDDEN_PATHS.includes(location.pathname)) return null;
  if (!localStorage.getItem('token')) return null;

  return (
    <>
      <motion.button
        data-testid="spirit-agent-fab"
        onClick={() => setOpen(true)}
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.94 }}
        transition={{ type: 'spring', stiffness: 280, damping: 22 }}
        className="fixed bottom-[10.5rem] right-5 md:bottom-28 md:right-8 z-40 w-16 h-16 rounded-full
          bg-gradient-to-br from-lime-300 via-emerald-400 to-cyan-500 text-black
          shadow-[0_0_36px_rgba(163,230,53,0.55)] flex items-center justify-center ring-2 ring-white/20"
        aria-label="Falar com o Spirit"
        title="Falar com o Spirit"
      >
        <motion.span
          className="absolute inset-0 rounded-full border border-lime-300/50"
          animate={{ scale: [1, 1.5], opacity: [0.6, 0] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: 'easeOut' }}
        />
        <Mic className="w-7 h-7 relative" strokeWidth={2.4} />
      </motion.button>
      <Suspense fallback={null}>
        <SpiritAgentSheet open={open} onClose={() => setOpen(false)} />
      </Suspense>
    </>
  );
}
